export default "/directory/static/is_qualified.4efd4eba.svg";